import { FormElement, Select } from 'mailup-web-components'
import {
  dynamicFieldState,
  senderConfigState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const DynamicSenderName = () => {
  const intl = useIntl()
  const dynamicOptions = useRecoilValue(dynamicFieldState)
  const [{ IdSenderNameField, customNameValueIsDirty }, setSenderConfig] =
    useRecoilState(senderConfigState)

  const handleChange = (e) => {
    const selectedOption = dynamicOptions.find((f) => f.value === e)

    setSenderConfig((prev) => ({
      ...prev,
      step2IsDirty: true,
      IdSenderNameField: selectedOption ? selectedOption.value : undefined,
      customNameValueIsDirty: true
    }))
  }

  return (
    <div>
      <FormElement
        required
        label={intl.formatMessage({
          id: 'Load.EmailSendingWizard.CustomSenderNameLabel'
        })}
        feedback={
          !IdSenderNameField && customNameValueIsDirty
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameRequired'
              })
            : undefined
        }
      >
        <Select
          value={IdSenderNameField}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'Load.Filters.IdentifierPlaceholder'
          })}
          options={dynamicOptions}
          error={!IdSenderNameField && customNameValueIsDirty}
          data-mu-test='select-dynamicOptionsName'
        />
      </FormElement>
    </div>
  )
}

export default DynamicSenderName
